import { render, staticRenderFns } from "./UcContractCard.yaml?vue&type=template&id=ae07dcce&component"
import script from "./UcContractCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports